function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#D34B18",
  fillOpacity: 0.15
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.75 22C20.6605 22 20.5707 21.9816 20.4862 21.9441L13.7415 18.9493H11.65C11.291 18.9493 11 18.6583 11 18.2993V12.7007C11 12.3417 11.291 12.0507 11.65 12.0507H13.7415L20.4862 9.05588C20.6871 8.9667 20.9201 8.98511 21.1042 9.10508C21.2886 9.22505 21.4 9.43007 21.4 9.65002V21.35C21.4 21.5699 21.2886 21.775 21.1042 21.8949C20.9972 21.9645 20.8738 22 20.75 22ZM12.3 17.6493H13.8793C13.9701 17.6493 14.0599 17.6684 14.143 17.7052L20.1 20.3502V10.6498L14.143 13.2948C14.0599 13.3317 13.9701 13.3507 13.8793 13.3507H12.3V17.6493Z",
  fill: "#D34714"
});

var SvgUnmuted = function SvgUnmuted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnmuted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unmuted.565af936.svg";
export { ForwardRef as ReactComponent };